'use client'

import { ComponentProps } from 'react'

import { Sheet, type SheetRootProps } from '@/shared/ui'

import { MobileHeader } from './header'
import { ImageList } from './image-list'
import { useLightbox } from '../../lib/lightbox'
import { MobileLightbox } from '../lightbox'

type Props = Pick<SheetRootProps, 'open' | 'onOpenChange'> & {
  onClose: () => void
  images: string[]
  roomName: string
  selectedIndex: number
  roomUrl: string | null
  onShared?: () => void
}

export const MobileImageGallery = ({
  open,
  onClose,
  images,
  roomName,
  selectedIndex,
  roomUrl,
  onShared,
  ...restProps
}: Props) => {
  const {
    lightboxIndex,
    open: openLightbox,
    close: closeLightbox,
  } = useLightbox()

  const handleLightboxClose = () => {
    closeLightbox()
  }

  const handleImageClick = (index: number) => {
    openLightbox(index)
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose?.()
    }
  }

  const handleInteractOutside: ComponentProps<
    typeof Sheet.Content
  >['onInteractOutside'] = event => {
    event.preventDefault()
  }

  return (
    <Sheet.Root
      open={open}
      onOpenChange={handleOpenChange}
      modal={false}
      {...restProps}
    >
      <Sheet.Content
        side="bottom"
        className="z-sheet h-full gap-0 border-none"
        onInteractOutside={handleInteractOutside}
      >
        <Sheet.Description className="sr-only">
          {roomName} 이미지 갤러리
        </Sheet.Description>
        <MobileHeader
          roomUrl={roomUrl}
          roomName={roomName}
          onShared={onShared}
        />
        <div className="h-0 grow overflow-y-auto">
          <ImageList
            images={images}
            roomName={roomName}
            selectedIndex={selectedIndex}
            onImageClick={handleImageClick}
            isMobile
          />
        </div>
        <MobileLightbox
          index={lightboxIndex}
          onClose={handleLightboxClose}
          images={images}
          roomName={roomName}
        />
      </Sheet.Content>
    </Sheet.Root>
  )
}
